export default "__VITE_ASSET__CquFfv7N__"